/* istanbul ignore file */
/**
 * Component configurations index
 * Aggregates all component theme configurations for easy importing
 */

import { buttonComponentConfig } from './button';
import { messageComponentConfig } from './message';
import { badgeComponentConfig } from './badge';
import { tagComponentConfig } from './tag';
import { avatarComponentConfig } from './avatar';
import { toolbarComponentConfig, breadcrumbComponentConfig } from './toolbar';
import { tabsComponentConfig, tabViewComponentConfig } from './tabs';
import { toggleButtonComponentConfig } from './toggle-button';
import { selectButtonComponentConfig } from './select-button';
import { autocompleteComponentConfig } from './autocomplete';
import { inputTextComponentConfig } from './input-text';
import { textareaComponentConfig } from './textarea';
import { dataTableComponentConfig } from './datatable';
import { accordionComponentConfig } from './accordion';
import { cardComponentConfig } from './card';
import { chipComponentConfig } from './chip';
import { menuComponentConfig } from './menu';
import { contextMenuComponentConfig } from './contextmenu';
import { toggleSwitchComponentConfig } from './toggle-switch';
import { dialog } from './dialog';
import { drawer } from './drawer';
import { popover } from './popover';
import { confirmpopup } from './confirmpopup';
import { tooltip } from './tooltip';
import { toast } from './toast';
import { progressbarComponentConfig } from './progressbar';

/**
 * Overlay components configuration
 */
export const overlayComponentsConfig = {
  dialog,
  drawer,
  popover,
  confirmpopup,
  tooltip,
  toast,
};

/**
 * Merges all component configurations into a single object
 * This allows for easier management and organization of component styles
 */
export const allComponentsConfig = {
  ...buttonComponentConfig,
  ...overlayComponentsConfig,
  ...messageComponentConfig,
  ...badgeComponentConfig,
  ...tagComponentConfig,
  ...avatarComponentConfig,
  ...toolbarComponentConfig,
  ...breadcrumbComponentConfig,
  ...tabsComponentConfig,
  ...tabViewComponentConfig,
  ...toggleButtonComponentConfig,
  ...selectButtonComponentConfig,
  ...autocompleteComponentConfig,
  ...inputTextComponentConfig,
  ...textareaComponentConfig,
  ...dataTableComponentConfig,
  ...accordionComponentConfig,
  ...cardComponentConfig,
  ...chipComponentConfig,
  ...menuComponentConfig,
  ...contextMenuComponentConfig,
  ...toggleSwitchComponentConfig,
  ...progressbarComponentConfig,
};

// Re-export individual configs for modularity
export { buttonComponentConfig };
export { messageComponentConfig };
export { badgeComponentConfig };
export { tagComponentConfig };
export { avatarComponentConfig };
export { toolbarComponentConfig, breadcrumbComponentConfig };
export { tabsComponentConfig, tabViewComponentConfig };
export { toggleButtonComponentConfig };
export { selectButtonComponentConfig };
export { autocompleteComponentConfig };
export { inputTextComponentConfig };
export { textareaComponentConfig };
export { dataTableComponentConfig };
export { accordionComponentConfig };
export { cardComponentConfig };
export { chipComponentConfig };
export { menuComponentConfig };
export { contextMenuComponentConfig };
export { progressbarComponentConfig };
export { toggleSwitchComponentConfig };

// Re-export individual overlay components for modularity
export { dialog };
export { drawer };
export { popover };
export { confirmpopup };
export { tooltip };
export { toast };
